/*
  Thank-you modal controller.
  Opens the modal when the page URL contains the configured query
  parameter (e.g. `?thanks=quote`). Closes on overlay click, close
  button click, Escape key. Clears the query param on close so a
  refresh does not re-open the modal.
*/

(function () {
  'use strict';

  function init() {
    var modal = document.querySelector('[data-ty-modal]');
    if (!modal) return;

    var paramName = modal.getAttribute('data-trigger-param') || 'thanks';
    var paramValue = modal.getAttribute('data-trigger-value') || 'quote';

    var params = new URLSearchParams(window.location.search);
    if (params.get(paramName) !== paramValue) return;

    openModal(modal, paramName);
  }

  function openModal(modal, paramName) {
    // Portal the modal to <body> so backdrop-filter sees the full
    // page behind it (overlay-group renders before <main> in the
    // DOM, and any wrapping section/section-group can create
    // stacking contexts that limit what backdrop-filter captures).
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    modal.removeAttribute('hidden');
    // Force reflow so the transition fires after the display change.
    void modal.offsetWidth;
    modal.classList.add('ty-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ty-modal-open');

    var previouslyFocused = document.activeElement;
    var closeBtn = modal.querySelector('[data-ty-modal-close]');
    if (closeBtn) closeBtn.focus();

    function cleanup() {
      modal.classList.remove('ty-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ty-modal-open');
      // Wait for the transition to finish before hiding entirely so
      // the close animation runs.
      var hideTimer = window.setTimeout(function () {
        modal.setAttribute('hidden', '');
      }, 250);

      // Strip the query param so a refresh does not re-open the modal.
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete(paramName);
        var newSearch = url.searchParams.toString();
        var newPath = url.pathname + (newSearch ? '?' + newSearch : '') + url.hash;
        window.history.replaceState({}, document.title, newPath);
      } catch (_e) {
        /* no-op */
      }

      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }

      // Detach listeners — modal can only open once per page load via URL param.
      document.removeEventListener('keydown', onKeyDown);
      window.clearTimeout(hideTimer);
    }

    function onKeyDown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        cleanup();
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', cleanup, { once: true });

    var overlay = modal.querySelector('[data-ty-modal-overlay]');
    if (overlay) overlay.addEventListener('click', cleanup, { once: true });

    document.addEventListener('keydown', onKeyDown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
